export default "__VITE_ASSET__Cck11CyS__"